import { render, staticRenderFns } from "./PotentialCustomers.vue?vue&type=template&id=56fc2abc"
import script from "./PotentialCustomers.vue?vue&type=script&lang=js"
export * from "./PotentialCustomers.vue?vue&type=script&lang=js"
import style0 from "./PotentialCustomers.vue?vue&type=style&index=0&id=56fc2abc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports